import React from 'react';
import { TextField } from '@mui/material';

export default function LlmNameField({
  value,
  onChange,
  disabled = false,
  required = false,
  error = false,
}) {
  const label = required ? 'Model Name' : 'Model Name (override)';
  let helper_text = '';
  if (error) {
    helper_text =
      required && !value
        ? 'Model name is required'
        : 'Must be a valid Hugging Face model name';
  }

  return (
    <TextField
      label={label}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
      required={required}
      error={error}
      helperText={helper_text}
    />
  );
}
